import { ValidationSchema } from 'validation-schema-library';

const identityDocumentsValidationSchema: ValidationSchema = {
  extendedInformation: {
    type: 'object',
    properties: {
      identityDocuments: {
        type: 'array',
        required: true,
        maxSize: 10,
        minSize: 1,
        forEach: {
          type: 'object',
          _divisible: false,
          properties: {
            type: {
              type: 'enum',
              required: true,
            },
            number: {
              type: {
                value: 'int',
                message: 'Only digits are allowed',
              },
              required: true,
              regex: [
                {
                  value: '^[0-9]{11}$',
                  when: {
                    '$.type': {
                      eq: 'PESEL',
                    },
                  },
                  message: 'Invalid PESEL number. The format is 11 digits number',
                },
                {
                  value: '^[0-9]{10}$',
                  when: {
                    '$.type': {
                      eq: 'NIP',
                    },
                  },
                  message: 'Invalid NIP number. The format is 10 digits number',
                },
              ],
              maxSize: [
                {
                  value: 20,
                  when: {
                    '$.type': {
                      in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                    },
                  },
                },
              ],
            },
            expiredAt: {
              required: {
                value: true,
                when: [
                  {
                    '$.type': {
                      in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                    },
                    $_PERMISSIONS: {
                      ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                    },
                  },
                  {
                    '$.type': {
                      in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                    },
                    $_IS_CREATE_REQUEST: {
                      eq: true,
                    },
                  },
                ],
              },
              type: {
                value: 'date',
                message: 'Please, enter a valid date',
              },
              minDate: '$NOW',
            },
            scansIds: {
              type: 'array',
              maxSize: 5,
              required: {
                value: true,
                when: [
                  {
                    '$.type': {
                      in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                    },
                    $_PERMISSIONS: {
                      ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                    },
                  },
                  {
                    '$.type': {
                      in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                    },
                    $_IS_CREATE_REQUEST: {
                      eq: true,
                    },
                  },
                ],
              },
            },
            documentDetails: {
              type: 'object',
              properties: {
                series: {
                  type: 'string',
                  required: {
                    value: true,
                    when: [
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT'],
                        },
                        $_PERMISSIONS: {
                          ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                        },
                      },
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT'],
                        },
                        $_IS_CREATE_REQUEST: {
                          eq: true,
                        },
                      },
                    ],
                  },
                  maxSize: {
                    value: 8,
                    message: 'Max length is 8 symbols',
                  },
                },
                citizenship: {
                  type: 'enum',
                  required: {
                    value: true,
                    when: [
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD', 'PESEL'],
                        },
                        $_PERMISSIONS: {
                          ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                        },
                      },
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD', 'PESEL'],
                        },
                        $initializationState: {
                          eq: 'FINALIZED',
                        },
                      },
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD', 'PESEL'],
                        },
                        $initializationState: {
                          eq: 'NEW',
                        },
                      },
                    ],
                  },
                },
                countryOfRegistration: {
                  type: 'enum',
                  required: {
                    value: true,
                    when: [
                      {
                        '$.type': {
                          eq: 'NIP',
                        },
                        $_PERMISSIONS: {
                          ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                        },
                      },
                      {
                        '$.type': {
                          eq: 'NIP',
                        },
                        $initializationState: {
                          eq: 'FINALIZED',
                        },
                      },
                      {
                        '$.type': {
                          eq: 'NIP',
                        },
                        $initializationState: {
                          eq: 'NEW',
                        },
                      },
                    ],
                  },
                },
                givenName: {
                  type: 'string',
                  required: {
                    value: true,
                    when: [
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_PERMISSIONS: {
                          ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                        },
                      },
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_IS_CREATE_REQUEST: {
                          eq: true,
                        },
                      },
                    ],
                  },
                  maxSize: {
                    value: 52,
                    message: 'Max length is 52 symbols',
                  },
                  regex: {
                    value: '^[a-zA-Z-]+$',
                    message: 'Only latin characters and hyphen',
                  },
                },
                surname: {
                  type: 'string',
                  required: {
                    value: true,
                    when: [
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_PERMISSIONS: {
                          ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                        },
                      },
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_IS_CREATE_REQUEST: {
                          eq: true,
                        },
                      },
                    ],
                  },
                  maxSize: {
                    value: 52,
                    message: 'Max length is 52 symbols',
                  },
                  regex: {
                    value: '^[a-zA-Z-]+$',
                    message: 'Only latin characters and hyphen',
                  },
                },
                issuedBy: {
                  required: {
                    value: true,
                    when: [
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_PERMISSIONS: {
                          ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                        },
                      },
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_IS_CREATE_REQUEST: {
                          eq: true,
                        },
                      },
                    ],
                  },
                  type: 'string',
                  maxSize: {
                    value: 64,
                    message: 'Max length is 64 symbols',
                  },
                },
                issuedAt: {
                  required: {
                    value: true,
                    when: [
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_PERMISSIONS: {
                          ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                        },
                      },
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_IS_CREATE_REQUEST: {
                          eq: true,
                        },
                      },
                    ],
                  },
                  type: {
                    value: 'date',
                    message: 'Please, enter a valid date',
                  },
                  maxDate: '$NOW',
                },
                personalIdNumber: {
                  type: 'string',
                  required: {
                    value: true,
                    when: [
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_PERMISSIONS: {
                          ct: 'UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS',
                        },
                      },
                      {
                        '$.type': {
                          in: ['PASSPORT', 'RESIDENCE_PERMIT', 'IDENTITY_CARD'],
                        },
                        $_IS_CREATE_REQUEST: {
                          eq: true,
                        },
                      },
                    ],
                  },
                  maxSize: 32,
                  regex: {
                    value: '^[^ ]+$',
                    message: 'Spaces are not allowed',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

const getIdentityDocumentsValidationSchema = () => Promise.resolve(identityDocumentsValidationSchema);

export default getIdentityDocumentsValidationSchema;
